import { MessageApi, messageService } from '@/utils/message';
import { App } from 'antd';
import React, { ReactNode, useEffect } from 'react';
// Provider component
export const UIProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  //const { modalContextHolder, messageApiHolder } = useModel('ui');

  // Value to be provided to consuming components
  const { message: messageApi } = App.useApp();

  useEffect(() => {
    messageService.setMessageInstance(messageApi);
    return () => {
      // clean up instance (optional)
      messageService.setMessageInstance(null as unknown as MessageApi);
    };
  }, [messageApi]);

  return (
    <>
      {/* {modalContextHolder} */}
      {/* {messageApiHolder} */}
      {children}
    </>
  );
};
